import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from './base.service';
// @ts-ignore
import {Observable} from "rxjs";
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';


export abstract class DefaultService extends BaseService {
    constructor(public http: HttpClient) {
        super();
    }

    create(queryParams:any) {

        return this.http.post(this.endpoint + this.resourceLink, queryParams)
            .pipe();
    }

    update(queryParams:any ) {
        const oneId = queryParams.id;
        delete queryParams.id;
        return this.http.put(this.endpoint + this.resourceLink + '/' + oneId, queryParams)
            .pipe(
            );
    }

    list(queryParams:any): Observable<any> {
        const httpParams = new HttpParams({ fromObject: queryParams });
        return this.http.get(this.endpoint + this.resourceLink, { params: httpParams });
    }

    getOne(queryParams:any) {
        const oneId = queryParams.id;
        delete queryParams.id;
        const httpParams = new HttpParams({ fromObject: queryParams });
        return this.http.get(this.endpoint + this.resourceLink + '/' + oneId, { params: httpParams });
    }

    remove(queryParams:any) {
        return this.http.delete(this.endpoint + this.resourceLink + '/' + queryParams.id)
            .pipe(
            );
    }


}
